import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Ba1110Class}from '../../Class/ba1110/ba1110-class'
import{Ba4010Class}from '../../Class/ba4010/ba4010-class'
import {environment} from '../../../environments/environment'
import { ADM0008Class } from '../../Class/ADM0008/adm0008-class';
// import { ADM0008ServiceService } from '../../../../../src/app/Service/ADM0008/adm0008-service.service';
// import { ADM0008Class } from '../../../../../src/app/Class/ADM0008/adm0008-class';
@Injectable({
  providedIn: 'root'
})
export class ADM0008ServiceService {

  baseUrl: string=environment.baseUrl + 'ADM008/';
  constructor(private http:HttpClient) { }




//Add or Edit an entry
Create(user_class:ADM0008Class): Observable<any>
{

 
  return this.http.post<any>(this.baseUrl+'Create',user_class);
}

Delete(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Delete/'+id);
}


LoadFind():Observable<any>
{

  return this.http.get<any>(this.baseUrl+'LoadFind');
}
LoadFindReport():Observable<any>
{

  return this.http.get<any>(this.baseUrl+'LoadFindReport');
}

}
